import React, { useState, useEffect } from 'react';
import './Chatbot.css';
import { FaArrowRight, FaTimesCircle } from 'react-icons/fa'; 
import { FiMinimize, FiMaximize } from 'react-icons/fi';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
  });
  const [messages, setMessages] = useState([
    { sender: 'bot', text: 'Hi, what can I do for you?' },
  ]);
  const [userInput, setUserInput] = useState('');
  const [isMinimized, setIsMinimized] = useState(false); 

  const handleToggleChatbot = () => {
    setIsOpen(prevIsOpen => !prevIsOpen);
  };
  
  const handleUserInputChange = (e) => {
    setUserInput(e.target.value);
  };

  const handleFormInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleSendMessage = () => {
    if (userInput.trim()) {
      const newMessages = [...messages, { sender: 'user', text: userInput }];
      setMessages(newMessages);

      if (step === 1) {
        setMessages([ 
          ...newMessages,
          { sender: 'bot', text: 'Please provide your name, phone number, and email to proceed.' },
        ]);
        setStep(2);
      } else if (step === 3) {
        const lowerCaseMessage = userInput.trim().toLowerCase();
        let responseMessage = '';

        if (lowerCaseMessage.includes('working hours')) {
          responseMessage = "Our working hours are from **09:00 to 18:00 hours**. The timings are location-specific.";
        } else if (lowerCaseMessage.includes('bangalore office address') || lowerCaseMessage.includes('karnataka office address')) {
          responseMessage = "Bengaluru:\n#4, 21st, Narayana Nagar 1st Block, Konanakunte, Bengaluru, India 560062\nPhone: +91-9449138831";
        } else if (lowerCaseMessage.includes('chennai office address') || lowerCaseMessage.includes('chennai')|| lowerCaseMessage.includes('chennai address')) {
          responseMessage = "Chennai:\n#9/2, Vivekananda St, Arumbakkam, Chennai, India 600106\nPhone:+91-7448465556";
        } else if (lowerCaseMessage.includes('tamil nadu office address') || lowerCaseMessage.includes('tamilnadu office address')|| lowerCaseMessage.includes('tamilnadu address')) {
          responseMessage = "Tamil Nadu Offices:\n\n" +
                            "Chennai:\n#9/2, Vivekananda St, Arumbakkam, Chennai, India 600106\nPhone:+91-7448465556\n\n" +
                            "Coimbatore:\n#1, 1st Floor, RG Pudur Pirivu, Above MRF Tyre Showroom, Chinniyampalayam, Coimbatore - 641 062, Tamilnadu, India.\nPhone: +91-94451 05983\n\n" +
                            "Tirupur:\n#37A Ramnagar 1st Street, Tirupur, India 641602\nPhone: +91-9865233369";
        } else if (lowerCaseMessage.includes('telangana office address') || lowerCaseMessage.includes('andhra pradesh office address') || lowerCaseMessage.includes('hyderabad office address')) {
          responseMessage = "Hyderabad:\n2-22-85/B, Allwyn colony rd, Vivekananda Nagar, Kukatpally, Hyderabad, Telangana 500072\nPhone: +91-94451 05983";
        } else if (lowerCaseMessage.includes('top products')) {
          responseMessage = "Our top products are:\n- HVLS Fans\n- Solar Panels\n- Air Coolers";
        } else if (lowerCaseMessage.includes('founder of this organization')) {
          responseMessage = "The founder of this organization is Venkatesh.";
        } else if (lowerCaseMessage.includes('sales team email id')) {
          responseMessage = "The Sales Team Email ID is: info@groupsui.in";
        } else if (lowerCaseMessage.includes('customer care email id')) {
          responseMessage = "The Customer Care Email ID is: info@groupsui.in";
        } else if (lowerCaseMessage.includes('service team email id')) {
          responseMessage = "The Service Team Email ID is: sskvservice@groupsui.in";
        } else if (lowerCaseMessage.includes('customer care number')) {
          responseMessage = "Our Customer Care Number is: +91-7448465556";
        } else if (lowerCaseMessage.includes('escalation') || lowerCaseMessage.includes('raise concern')) {
          responseMessage = "For escalation or to raise a concern, please contact: Venkatesh@groupsui.in";
        } else if (lowerCaseMessage.includes('location') || lowerCaseMessage.includes('where') || lowerCaseMessage.includes('address')) {
          responseMessage = "We have 5 locations. You want location details? Please visit our Contact Us Page.";
        } else {
          responseMessage = "Sorry, do you want more details? Please contact our customer support at +91-7448465556.";
        }

        setMessages([
          ...newMessages,
          { sender: 'bot', text: responseMessage },
        ]);
      }

      setUserInput('');
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    const timestamp = new Date().toISOString();
    const dataToSend = { ...formData, timestamp };
  
    try {
      // Update the URL to your live backend URL
      const response = await fetch('https://sskvbackend.onrender.com/api/chatbot-details', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataToSend),
      });
  
      const result = await response.json();
  
      if (result.success) {
        setMessages([
          ...messages,
          { sender: 'bot', text: `Thank you, ${formData.name}. Your details have been saved. How can I assist you today?` },
        ]);
        setFormData({ name: '', phone: '', email: '' });
        setStep(3);
      } else {
        setMessages([...messages, { sender: 'bot', text: 'There was an issue saving your details. Please try again.' }]);
      }
    } catch (error) {
      setMessages([...messages, { sender: 'bot', text: 'Error connecting to the server. Please try again later.' }]);
    }
  };

  const handleMinimizeChatbot = () => {
    setIsMinimized((prevIsMinimized) => !prevIsMinimized);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default "Enter" action (such as submitting a form)
      handleSendMessage(); // Trigger the send message function when Enter is pressed
    }
  };

  return (
    <>
    {/* Chatbot toggle button */}
    {!isOpen && (
      <button className="chatbot-toggle-btn" onClick={handleToggleChatbot}>
        <div className="call-center-img"></div> {/* Display custom image */}
      </button>
    )}

    {isOpen && (
      <div className={`chatbot-container ${isMinimized ? 'minimized' : ''}`}>
        {/* Chatbot Header with minimize and close icons */}
        <div className="chatbot-header">
          <span className="chatbot-title">Chatbot</span>
          <div className="chatbot-controls">
            <button onClick={handleMinimizeChatbot} className="chatbot-control-btn">
              {isMinimized ? (
                <FiMaximize size={24} color="white" />  // Maximize Icon
              ) : (
                <FiMinimize size={24} color="white" />  // Minimize Icon
              )}
            </button>
            <button onClick={handleToggleChatbot} className="chatbot-control-btn">
              ✖ {/* Close Icon */}
            </button>
          </div>
        </div>

        {/* Chatbot Content */}
        {!isMinimized && (
          <>
            <div className="chatbot-messages">
              {messages.map((msg, index) => (
                <div key={index} className={`chatbot-message ${msg.sender}`}>
                  {msg.text}
                </div>
              ))}
            </div>

            {step === 2 && (
              <form className="chatbot-form" onSubmit={handleFormSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleFormInputChange}
                  required
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone"
                  value={formData.phone}
                  onChange={handleFormInputChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleFormInputChange}
                  required
                />
                <button type="submit">Submit</button>
              </form>
            )}

            {step !== 2 && (
              <div className="chatbot-input-container">
                <input
                  type="text"
                  className="chatbot-input"
                  placeholder="Type your message..."
                  value={userInput}
                  onChange={handleUserInputChange}
                  onKeyDown={handleKeyDown} // Added keydown event listener
                />
                <button onClick={handleSendMessage}>
                  <FaArrowRight size={20} color="white" />
                </button>
              </div>
            )}
          </>
        )}
      </div>
    )}
  </>
  );
};

export default Chatbot;
